export const SOIL_TEXTURE_PALETTE = {
  sand: '#27f024',
  sandy_loam: '#eb8334',
  loam: '#2b8cbe',
  clay: '#e34a33',
  muck: '#542788',
  fallback: '#bdbdbd'
};

export const SOIL_DRAINAGE_PALETTE = {
  well_drained: '#2b8cbe',
  moderate: '#fdae61',
  poor: '#d73027',
  fallback: '#999999'
};

export const SOIL_LEGEND_TEXTURE = [
  { label: 'Sand', color: SOIL_TEXTURE_PALETTE.sand },
  { label: 'Sandy loam', color: SOIL_TEXTURE_PALETTE.sandy_loam },
  { label: 'Loam', color: SOIL_TEXTURE_PALETTE.loam },
  { label: 'Clay', color: SOIL_TEXTURE_PALETTE.clay },
  { label: 'Muck', color: SOIL_TEXTURE_PALETTE.muck }
];

export const SOIL_LEGEND_DRAINAGE = [
  { label: 'Well drained', color: SOIL_DRAINAGE_PALETTE.well_drained },
  { label: 'Moderate', color: SOIL_DRAINAGE_PALETTE.moderate },
  { label: 'Poor / holds water', color: SOIL_DRAINAGE_PALETTE.poor }
];

